import script from "./pushConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./pushConfirm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__